import { apiService } from './apiService';

export const NOTIFICATIONS_CHANGED_EVENT = 'notifications:changed';
export const notifyNotificationsChanged = () => window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
export const isNotificationRead = (item: any) => {
  const value = item.is_read ?? item.read;
  return value === true || value === 1 || value === '1' || value === 'true';
};

const completeMutation = async (request: ReturnType<typeof apiService.put>) => {
  const response = await request;
  if (!response.success) throw new Error(response.message || 'Bildirim güncellenemedi');
  notifyNotificationsChanged();
  return response;
};

export const notificationService = {
  async getNotifications(params?: { userId?: string; unreadOnly?: boolean; compact?: boolean; limit?: number }) {
    if (params?.userId) {
      return await notificationService.getByUser(params.userId, {
        ...(params.unreadOnly ? { isRead: false } : {}),
        compact: params.compact,
        limit: params.limit,
      });
    }

    return await apiService.get('/notifications');
  },

  async getByUser(userId: string, filters?: { isRead?: boolean; compact?: boolean; limit?: number }) {
    const params = new URLSearchParams();
    if (filters?.isRead !== undefined) params.append('isRead', String(filters.isRead));
    if (filters?.compact) params.append('compact', 'true');
    if (filters?.limit) params.append('limit', String(filters.limit));
     
    const query = params.toString();
    return await apiService.get(`/notifications/user/${userId}${query ? `?${query}` : ''}`);
  },

  async markAsRead(id: string | number) {
    return completeMutation(apiService.put(`/notifications/${id}/read`, {}));
  },

  async markAllAsRead(userId: string) {
    return completeMutation(apiService.put(`/notifications/user/${userId}/read-all`, {}));
  },

  async delete(id: string | number) {
    return completeMutation(apiService.delete(`/notifications/${id}`));
  },

  async deleteAllByUser(userId: string) {
    return completeMutation(apiService.delete(`/notifications/user/${userId}`));
  },

  async create(data: any) {
    return await apiService.post('/notifications', data);
  },

  async registerPushToken(token: string, platform: string) {
    return await apiService.post('/notifications/register-token', { token, platform });
  },

  async sendTestPush(data: { userId?: string | number; userIds?: Array<string | number>; title?: string; message?: string; channelId?: string; sound?: string }) {
    return await apiService.post('/notifications/test-push', data);
  },

  async sendLocationReminder(data: { userIds: Array<string | number>; message: string; channels: { sms: boolean; push: boolean; sound: boolean } }) {
    return await apiService.post('/notifications/location-reminder', data);
  },
};
